<template>
  <v-card :loading="loading">
    <v-form>
      <v-container>
        <fieldset>
          <legend>Call Details</legend>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <label class="custom-label">Full Name</label>
              <v-text-field
                v-model="data.full_name"
                :error-messages="errors.full_name"
                label="Full Name"
                placeholder="Full Name"
                solo
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <label class="custom-label">Contact Number</label>
              <v-text-field
                label="Contact Number"
                v-model="data.contact_number"
                :error-messages="errors.contact_number"
                placeholder="Contact Number"
                type="number"
                solo
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <label class="custom-label">Email</label>
              <v-text-field
                label="Email"
                v-model="data.email"
                :error-messages="errors.email"
                type="email"
                placeholder="Email"
                solo
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <label class="custom-label">Recent Qualification</label>
              <v-text-field
                v-model="data.qualification"
                :error-messages="errors.qualification"
                label="Recent Qualification"
                placeholder="Recent Qualification"
                solo
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <label class="custom-label">How to deliver the lesson?</label>
              <v-select
                v-model="data.lesson_type"
                :error-messages="errors.lesson_type"
                :items="lesson_type"
                label="Lesson type"
                placeholder="Lesson type"
                solo
                item-value="id"
                item-text="label"
                single-line
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <label class="custom-label">Upload Cv</label>
              <v-file-input
                show-size
                label="Choose File"
                @change="file($event)"
                :error-messages="errors.cv"
                prepend-icon
                chips
                solo
                accept="application/pdf"
              ></v-file-input>
            </v-col>
          </v-row>
        </fieldset>

        <v-row>
          <v-col cols="12">
            <v-btn :loading="loading" @click="save()" color="primary"
              >Save</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
import Form from "../../utils/form/Form";
import { DAYSSELECTOR } from "../../utils/constants";
import { Countries } from "../../utils/constants";

export default {
  name: "AddTutorData",
  props: {
    id: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      errors: {},
      lesson_type: [
        {
          id: 1,
          label: "In-centre",
        },
        {
          id: 2,
          label: "online",
        },
        {
          id: 3,
          label: "Online & In-centre",
        },
      ],

      data: {
        lesson_type: "",
        full_name: "",
        email: "",
        contact_number: "",
        cv: null,
        qualification: "",
      },

      loading: true,
    };
  },
  methods: {
    file(e) {
      this.data.cv = event.target.files[0];
    },
    save() {
      if (this.$route.params.id) {
        this.update();
      } else {
        this.create();
      }
    },
    create() {
      let form = new Form({
        ...this.data,
      });
      form
        .post(apiRoutes.TutorCv.url)
        .then((response) => {
          this.$router.replace({
            name: "RecordManagement",
          });
        })
        .catch((response) => {
          // cons/ole.log(response);
          if (response.status === 400) {
            this.errors = response.data;
          }
          if (response.status === 422) {
            this.errors = response.data.errors;
          }
        });
    },
    update() {
      let form = new Form({
        ...this.data,
      });
      form
        .post(apiRoutes.TutorCv.update + "/" + this.$route.params.id)
        .then((response) => {
          this.$router.replace({
            name: "RecordManagement",
          });
        })
        .catch((response) => {
          if (response.status === 422) {
            this.errors = response.data.errors;
          }
        });
    },
  },
  mounted() {
    this.loading = false;
    if (this.$route.params.id) {
      this.loading = true;

      axios
        .get(apiRoutes.TutorCv.url + "/" + this.$route.params.id)
        .then((response) => {
          this.loading = false;

          this.data.full_name = response.data.response.fname;
          this.data.email = response.data.response.email;
          this.data.qualification = response.data.response.qualification;
          this.data.lesson_type = response.data.response.lesson_type;
          this.data.cv = response.data.response.cv;

          this.data.contact_number = response.data.response.contact_no;
        });
    }
  },
};
</script>

<style lang="scss" scoped>
fieldset {
  border: 0;

  &:not(:last-of-type) {
    border-bottom: 1px dashed #8898aa80;
    margin-bottom: 20px;
  }

  & legend {
    font: Bold 20px/25px Lato;
    color: #172b4d;
  }
}
</style>
